import { FC, useState } from 'react';
import { Color, ColorSlider, parseColor } from '@adobe/react-spectrum';
import { PickerProps } from './_models';

const PickerComponent: FC<PickerProps> = ({ color, onChange }) => {
  const [colorValue, setColorValue] = useState(
    parseColor(color).toFormat('hsl')
  );

  const onHueChange = (value: Color) => {
    setColorValue(value.withChannelValue('saturation', 100));
  };

  const onChangeEnd = () => {
    onChange(colorValue.toString('hex'));
  };

  return (
    <div className="d-flex flex-column gap-2">
      <ColorSlider
        width="size-3000"
        value={colorValue}
        channel="hue"
        onChange={onHueChange}
        onChangeEnd={onChangeEnd}
        aria-label="Hue"
      />

      <ColorSlider
        width="size-3000"
        value={colorValue}
        channel="lightness"
        onChange={setColorValue}
        onChangeEnd={onChangeEnd}
        aria-label="Saturation"
      />
    </div>
  );
};

export default PickerComponent;
